import { render, staticRenderFns } from "./solutionsTab4.vue?vue&type=template&id=f7e1a090&"
import script from "./solutionsTab4.vue?vue&type=script&lang=js&"
export * from "./solutionsTab4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports